module.exports = __webpack_public_path__ + "img/benefits01.67ad106.png";